
import classnames from 'classnames';
import Utils from 'Utils';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Row, Modal, Button, Typography, message, Checkbox } from 'antd';
import styles from './style.scss?__local';
import { confirmProtocol, getProtocol } from '../../wup'
import useTitle from 'useTitle';
import useFooter from 'useFooter';
import useH5 from 'useH5';
import login from 'login';

const { Title, Paragraph, Text } = Typography;

function ProLink() {
  return <a href="https://blog.huya.com/product/116">《主播服务协议》</a>
}

export default function Protocols(route) {
  useTitle('虎牙平台主播能量豆佣金确认协议')
  const [isH5] = useH5()
  !isH5 && useFooter()

  const [sign, setSign] = useState(false)
  const [acting, setActing] = useState(false)
  const [loading, setLoading] = useState(true)
  const [check, setCheck] = useState(false)

  const confirm = useCallback(() => {
    if (!check) {
      return Modal.confirm({
        icon: null,
        title: '',
        content: <>请阅读并同意<ProLink /></>,
        onOk: () => setCheck(true),
        cancelText: '取消',
        okText: '确定',
        width: isH5 ? 280 : '',
        className: isH5 ? 'h5modal' : ''
      })
    }
    setActing(true)
    login.sudo(isH5).then(() => {
      confirmProtocol()
        .then(res => {
          setActing(false)
          setSign(true)
          message.info('操作成功')
        })
        .catch(err => {
          setActing(false)
          message.info(err.message || '操作失败')
        })
    })
      .catch((err) => setActing(false))
  }, [check, isH5])

  // 状态更新
  useEffect(() => {
    getProtocol()
      .then(res => {
        const { confirmedInfo } = res || {}
        const { confirmStatus } = confirmedInfo || {}
        if (confirmStatus) {
          setSign(true)
        }
      })
      .catch(err => { })
      .finally(() => setLoading(false))
    return () => { }
  }, [])

  return (
    <Row type="flex" justify="center" className={styles['context']}>
      <div className={styles['context-info']}>
        <Title className={styles['title']} level={3}>虎牙平台主播能量豆佣金通知</Title>
        <div className={styles['date']}><Text disabled>更新日期：2023年1月31日</Text></div>
        <Paragraph className={styles['pleft']}>尊敬的主播：</Paragraph>
        <Paragraph className={styles['p']}>您在使用直播间互动小程序（包括战争冲突、虎牙领主争霸等）期间产生能量豆佣金收益，详细的记录可登录虎牙个人中心或虎牙佣金系统查看，提现流程与虎牙平台佣金提现流程一致。</Paragraph>
        <Paragraph className={styles['p']}>请您点击下方按钮确认，以确保提现流程顺利进行。欢迎您的继续使用！</Paragraph>
        <Checkbox className={styles['p']} checked={check || sign} onChange={(e) => setCheck(e.target.checked)}>已阅读并同意<a href="https://blog.huya.com/product/116">《主播服务协议》</a></Checkbox>
      </div>

      <div className={styles['context-btns']}>
        {sign ?
          <Button className={styles['cbtn']} type="primary" size="large" shape="round" block disabled>已确认</Button> :
          <Button className={styles['cbtn']} type="primary" size="large" shape="round" block loading={loading || acting}
            onClick={() => confirm()}>确认</Button>
        }
      </div>
    </Row>

  )
}
